import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useContext, useEffect, useState } from 'react';
import { APIContext } from '../../../Contexts/APIContext';
import DropDownViewModel from '../../../Utilities/ViewModels/DropDownViewModel';
import MonitoringReportTabsV1 from './MonitoringReportV1/MonitoringReportTabsV1';
import MonitoringReportTabsV2 from './MonitoringReportV2/MonitoringReportTabsV2';
import { buildMonitoringReportEndTimeOptions } from './MonitoringReportShared/surveyTimeOptions';
import EditControl from '../EditControl';
import AddIcon from '@mui/icons-material/Add';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';

interface IProps {
    id: string;
    hasTravelPlan?: boolean | null;
    reloadSite?: () => void;
}
export default function TravelPlanMonitoringReportContainer(props: IProps) {
    const { get, post, showMessage } = useContext(APIContext);

    const [travelPlanTypes, setTravelPlanTypes] = useState<DropDownViewModel[]>([]);
    const [travelPlanTargetGroups, setTravelPlanTargetGroups] = useState<DropDownViewModel[]>([]);
    const [travelPlanVersion, setTravelPlanVersion] = useState<number | null>(null);
    const [surveyTimesDropdown, setSurveyTimesDropdown] = useState<DropDownViewModel[]>([]);
    const [surveyEndTimesDropdown, setSurveyEndTimesDropdown] = useState<DropDownViewModel[]>([]);
    const [parametersDropdown, setParametersDropdown] = useState<DropDownViewModel[]>([]);
    const [modeDropdown, setModeDropdown] = useState<DropDownViewModel[]>([]);
    const [readOnly, setReadOnly] = useState(true);
    const [creating, setCreating] = useState(false);


    useEffect(() => {
        if (props.id) {
            getValues();
        }
    }, [props.id]);

    const createTravelPlan = async () => {
        setCreating(true);
        await post('TravelPlan', `CreateTravelPlanV2?reference=${props.id}`, {}, (version: number) => {
            setTravelPlanVersion(version);
            showMessage('success', 'Travel Plan V2 added; its monitoring report is now available');
            props.reloadSite?.();
        });
        setCreating(false);
    };

    useEffect(() => {
        setSurveyEndTimesDropdown(buildMonitoringReportEndTimeOptions(surveyTimesDropdown));
    }, [surveyTimesDropdown]);

    const getValues = () => {
        const [, mainUse, subUse] = props.id.split('-');
        get('TravelPlan', `GetTravelPlanTypes`, setTravelPlanTypes)
        get('TravelPlan', `GetTravelPlanTargetGroups`, setTravelPlanTargetGroups)
        get('TravelPlan', `GetTravelPlanVersion?id=${props.id}`, (version: number | null | undefined) => setTravelPlanVersion(version ?? null))
        get("SurveyDays", `GetParametersAvailableForSurveyDropdown?mainUse=${mainUse}&subUse=${subUse}`, setParametersDropdown)
        get("SurveyDays", `GetAvailableTimeRangeForSurvey?surveyReference=${props.id}`, setSurveyTimesDropdown)
        get("Site", `GetAvailableModesForSite?reference=${props.id}`, (modes: DropDownViewModel[]) => {
            const totalPeopleModeIds = [3, 4, 5, 6, 38];
            const modeIds = new Set(modes.map(mode => Number(mode.id)));
            const hasAllTotalPeopleModes = totalPeopleModeIds.every(id => modeIds.has(id));
            const hasTotalPeople = modeIds.has(-1);

            setModeDropdown(hasAllTotalPeopleModes && !hasTotalPeople
                ? [...modes, { id: -1, label: "Total People" }]
                : modes);
        })
    }

    return (
        <>
            {travelPlanVersion === null ?
                <>
                    <Typography variant="h6" sx={{ p: 2 }}>
                        {creating ? 'Adding Travel Plan V2...' : 'A monitoring report requires a Travel Plan. Enter edit mode, then select Add.'}
                    </Typography>
                    {props.hasTravelPlan === false && (
                        <>
                            <EditControl readOnly={readOnly} setReadOnly={setReadOnly} showSave={false} />
                            {!readOnly && (
                                <Tooltip title="Add Travel Plan V2">
                                    <Fab
                                        color="primary"
                                        disabled={creating}
                                        onClick={createTravelPlan}
                                        sx={{ position: 'absolute', bottom: 16, right: 16 }}
                                    >
                                        <AddIcon />
                                    </Fab>
                                </Tooltip>
                            )}
                        </>
                    )}
                </>
                :
                <Box width="100%">
                    {travelPlanVersion == 1 &&
                        <MonitoringReportTabsV1 typeDropdown={travelPlanTypes} groupDropdown={travelPlanTargetGroups} id={props.id} surveyTimesDropdown={surveyTimesDropdown} surveyEndTimesDropdown={surveyEndTimesDropdown} parameterDropdown={parametersDropdown} modeDropdown={modeDropdown} />
                    }
                    {travelPlanVersion == 2 &&

                        <MonitoringReportTabsV2 typeDropdown={travelPlanTypes} groupDropdown={travelPlanTargetGroups} id={props.id} surveyTimesDropdown={surveyTimesDropdown} surveyEndTimesDropdown={surveyEndTimesDropdown} parameterDropdown={parametersDropdown} modeDropdown={modeDropdown} />
                    }
                </Box>
            }
        </>
    );
}
